import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ title, subtitle, moreTo, moreLabel = "查看全部" }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="flex items-start gap-3">
        <span className="mt-1 w-1 h-6 md:h-7 rounded-full bg-accent-500 shrink-0"></span>
        <div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">{title}</h2>
          {subtitle && <p className="mt-1 text-xs md:text-sm text-foreground-500">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 flex items-center gap-1 text-sm text-secondary-600 hover:text-secondary-700 font-medium whitespace-nowrap transition-colors cursor-pointer"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      )}
    </div>
  );
}